export default "__VITE_ASSET__Bnk55VoW__"